import * as React from 'react';
import * as styles from './styles.less';
import { classNames } from '../../../Shared/utils/classnames';
import { SvgIcon } from '../svg-icon';
import iphoneOverlay from '../../assets/svg/iphone-x.svg';
import { AppContentCardType } from '../../webgiving-generated';
import { ButtonStyle } from '../../primitives/button/button';
import { ButtonLink } from '../../primitives/button/button-link';
import { AppContentCardDisplayCard } from './app-content-card-display-card';
import { Text } from '../../components/text';

export interface IAppContentCardProps {
	id: string;
	appName: string;
	getAppUrl: string;
	cardType: AppContentCardType;
	title: string;
	isFeatured: boolean;
	subtitle?: string;
	summary?: string;
	imageUrl?: string;
	tabName?: string;
	eventStartTime?: Date | null;
	eventEndTime?: Date | null;
	isAllDayEvent?: boolean;
}

export const AppContentCard:React.SFC<IAppContentCardProps> = (props: IAppContentCardProps) => {
	return (
			<div className={styles.container}>
				<div className={styles.phoneContainer}>
					<div className={styles.cardContainer}>
						<div className={classNames(styles.card, styles.topCard)} />
						<AppContentCardDisplayCard {...props} />
						<div className={classNames(styles.card, styles.bottomCard)} />
					</div>
					<div className={styles.phoneOverlay}><SvgIcon svg={iphoneOverlay} /></div>
					<div className={classNames(styles.banner, 'app-content-card-banner-bg')}>
						<Text>{getBannerText(props.cardType)}</Text>
					</div>
				</div>
				<div className={styles.ctaWrapper}>
					<div className={styles.cta}>
						{renderCallToAction(props.cardType, props.appName)}
						<ButtonLink href={`${props.getAppUrl}&cardType=${AppContentCardType[props.cardType]}`}
							acceptanceTestTargetId="Get app link"
							className="button"
							buttonStyle={ButtonStyle.Ghost}
							style={{width: '144px'}}
							openNewTab={true}><Text>Go to App</Text></ButtonLink>
					</div>
				</div>
			</div>
		);
};

const renderCallToAction = (cardType: AppContentCardType, appName: string) => {
	switch(cardType) {
		case AppContentCardType.Default:
		case AppContentCardType.Video:
			return <div className={styles.ctaText}><Text>{`To see more and stay connected with us, visit `}</Text><strong><Text params={{name: formatAppName(appName)}}>{`{{name}}`}</Text></strong>!</div>
		case AppContentCardType.Event:
			return <div className={styles.ctaText}><Text>{`Find out more about this event and stay connected through `}</Text><strong><Text params={{name: formatAppName(appName)}}>{`{{name}}`}</Text></strong>!</div>
		case AppContentCardType.Audio:
			return <div className={styles.ctaText}><Text>{`Listen to this podcast and stay connected through `}</Text><strong><Text params={{name: formatAppName(appName)}}>{`{{name}}`}</Text></strong>!</div>
		case AppContentCardType.Unknown:
		default:
			throw new Error(`Unknown card type: ${AppContentCardType[cardType]}`);
	}
};

const getBannerText = (cardType: AppContentCardType) => {
	switch(cardType) {
		case AppContentCardType.Default:
			return 'From our App';
		case AppContentCardType.Audio:
			return 'Recent Podcast';
		case AppContentCardType.Event:
			return 'Upcoming Event';
		case AppContentCardType.Video:
			return 'Recent Video';
		case AppContentCardType.Unknown:
		default:
			throw new Error(`Unknown card type: ${AppContentCardType[cardType]}`);
	}
};

const formatAppName = (appName: string) => {
	const nameParts = appName.trim().toLowerCase().split(' ');
	const startsWithThe = nameParts[0] === 'the';
	const endsWithApp = nameParts[nameParts.length - 1] === 'app';

	return `${!startsWithThe ? 'the ':''}${appName}${!endsWithApp ? ' app':''}`;
};
